import { Box } from "@mui/material";
import { useState } from "react";
import colors from "../../../design/colors";
import downArrow from "../../../../assets/gusers-and-teams-down-arrow.svg";
import customStyles from "./styles";

const VerifiedNumbersSection = ({
  contacts = [],
  maxContacts = 5,
  onCompleteKyc,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const verifiedCount = contacts?.length || 0;

  return (
    <Box
      sx={{
        borderTop: `1px solid ${colors.nc_gray_300}`,
        width: "100%",
      }}
    >
      {/* Toggle header */}
      <Box
        onClick={() => setIsExpanded((prev) => !prev)}
        sx={customStyles.verifiedNumbersHeader}
      >
        <span className="t7 regular-font nc-gray-700">
          Verified numbers ({verifiedCount} of {maxContacts})
        </span>
        <img
          src={downArrow}
          alt=""
          style={{
            rotate: isExpanded ? "180deg" : "0deg",
            width: "14px",
            height: "14px",
            transition: "rotate 0.2s ease",
          }}
        />
      </Box>

      {/* Expanded content */}
      {isExpanded && (
        <Box
          sx={customStyles.verifiedNumbersContent}
        >
          {/* Number chips */}
          {verifiedCount > 0 && (
            <Box
              sx={customStyles.chip}
            >
              {contacts.map((contact, index) => (
                <span
                  key={index}
                  className="t8 regular-font"
                  style={customStyles.chipText}
                >
                  {contact.number}
                </span>
              ))}
            </Box>
          )}

          {/* Complete KYC link */}
          <p
            className="t8 regular-font"
            style={{
              margin: 0,
              lineHeight: "18px",
            }}
          >
            <span
              className="medium-font"
              style={{
                color: colors.ic_green_400,
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={(e) => {
                e.stopPropagation();
                onCompleteKyc();
              }}
            >
              Complete KYC
            </span>{" "}
            <span className="nc-gray-600">
              to remove outgoing call restrictions during trial.
            </span>
          </p>
        </Box>
      )}
    </Box>
  );
};

export default VerifiedNumbersSection;
